const VPCSC_CHECK_FAILED_CODE = 'auth/vpcsc-check-failed';

// Bounds the walk through wrapping errors, so a cyclic `cause` cannot loop.
const MAX_WRAPPING_DEPTH = 5;

const isRefusal = (error: unknown, depth: number): boolean => {
  if (depth > MAX_WRAPPING_DEPTH || typeof error !== 'object' || error === null) {
    return false;
  }
  if ('code' in error && error.code === VPCSC_CHECK_FAILED_CODE) {
    return true;
  }
  return (
    ('networkError' in error && isRefusal(error.networkError, depth + 1)) ||
    ('cause' in error && isRefusal(error.cause, depth + 1))
  );
};

/**
 * Whether the user's network refused a request to Identity Platform under VPC Service Controls, raised directly or
 * as the `networkError` or `cause` of an error wrapping it.
 */
export const isVpcscCheckFailedError = (error: unknown): boolean => isRefusal(error, 0);
